import { useMemo } from 'react';
import { useOrgContext } from '@provider-directory/components/org-context/org-context-provider';
import {
  createIsPrimaryCareSpecialty,
  type IsPrimaryCareSpecialtyFn,
} from '@provider-directory/types/search.model';

export const useIsPrimaryCareSpecialty = (): IsPrimaryCareSpecialtyFn => {
  const { config } = useOrgContext();
  const keywordsKey = JSON.stringify(config.primaryCareKeywords);
  return useMemo(
    () => createIsPrimaryCareSpecialty(config.primaryCareKeywords),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [keywordsKey],
  );
};
